import { FC, memo, useMemo } from 'react';
import { Carousel } from 'antd';
import { Image } from '@shuwen/wenlv-web-activity-library';
import styles from './index.module.scss';
import { ThemeRoutePlaceInfo } from '@/store/types';

interface Props {
  index: number;
  item: ThemeRoutePlaceInfo;
  length: number;
}

const TimeSpot: FC<Props> = ({ item, index, length }) => {

  const data = useMemo(() => {
    const arr = item?.ext_neighborList?.filter(i => i.vertex?.content);
    if (arr?.length) return arr;
    return null;
  }, [item]);

  return (
    <div className={styles.timeSpot}>
      <div className={styles.titleImg}>
        <Image src={item.image} className={styles.img} />
      </div>
      <div className={styles.content}>
        <div className={styles.num}>{index > 8 ? index + 1 : '0' + (index + 1)}</div>
        <div
         className={styles.title}
          style={{fontSize: item.name.length > 10 ?  18 : item.name?.length > 7 ? 25 : '' }}
          >
            {item.name}
          </div>
        <div className={styles.detail}>
          {
            data ?
              <Carousel
                className={styles.carousel}
                dots={false}
                autoplay={length > 7 ? false : true}
                autoplaySpeed={10000}
              >
                {
                  data.map((item) => (
                    <div className={styles.item} key={item.vertex.entityId}>
                      <div className={styles.time}>{item.vertex?.dynasty}</div>
                      <div className={styles.theme}>《{item.vertex?.name?.replace('《', '')?.replace('》','')}》</div>
                      <div className={styles.author}>{item.vertex?.author?.[0]}</div>
                      <div className={styles.poem}>{item.vertex?.content}</div>
                    </div>
                  ))
                }
              </Carousel>
              : null
          }
        </div>
      </div>
    </div>
  )
}

export default memo(TimeSpot);
